module.exports = __webpack_public_path__ + "static/media/purple-s-10.a6831033.png";